import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DailyPageState } from "./types";

const initialState: DailyPageState = {
  selectedCompetitorBrandId: null,
};

const dailyPageSlice = createSlice({
  name: "dailyPage",
  initialState,
  reducers: {
    setSelectedCompetitorBrandId: (state, action: PayloadAction<number | null>) => {
      state.selectedCompetitorBrandId = action.payload;
    },
  },
});

export const { setSelectedCompetitorBrandId } = dailyPageSlice.actions;

export default dailyPageSlice.reducer;
